import Button from 'components/Button/Button';
import React, { Fragment } from 'react';

// Import components
import './ButtonRow.module.scss';

type Props = {
  item: any;
};

export default function ButtonRow({ item }: Props) {
  // console.log(item, 'item');
  return (
    <div styleName="ButtonRow">
      {item.attributes.buttons.map((item, i) => (
        // <Button key={i}>test</Button>
        <Fragment key={i}>
          {item.attributes.type === 'link_external' ? (
            <a href={item.attributes.link} target="_blank" rel="noreferrer">
              <Button>{item.attributes.title}</Button>
            </a>
          ) : (
            <Button to={item.attributes.link}>{item.attributes.title}</Button>
          )}
        </Fragment>
      ))}
    </div>
  );
}
